import { render, staticRenderFns } from "./XChart.vue?vue&type=template&id=676ed4a8&scoped=true"
import script from "./XChart.vue?vue&type=script&lang=js"
export * from "./XChart.vue?vue&type=script&lang=js"
import style0 from "./XChart.vue?vue&type=style&index=0&id=676ed4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ed4a8",
  null
  
)

export default component.exports